
import React from "react";
import { i18nManager } from "../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { ITournamentEdition } from "../../../../../services";

interface StageFormatBracketProps {
    tournamentEdition: ITournamentEdition;
    dataComponentState: [React.ReactElement | undefined, React.Dispatch<React.SetStateAction<React.ReactElement | undefined>>];
}

function StageFormatBracket(props: StageFormatBracketProps) {

    const { tournamentEdition } = props;
    const [dataComponent, setDataComponent] = props.dataComponentState;
    const labels = i18nManager.Labels.host.manage_tournament.participants;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    React.useEffect(() => {
        fetchInformation();

        return () => {
            setDataComponent(undefined);
        };
    }, []);

    return (<div className="mt-stage-format-bracket">
        Hello there
    </div>);

    function fetchInformation() {
        
    }

}

export default StageFormatBracket;
